export const organizationDetailsKey =
  'descriptions.admin-portal.organizations.details';

export const organizationActionsKey = organizationDetailsKey.concat('.actions');
